module.exports = new __parcel__URL__("john-wick-chapter-2.54eac932.jpg").toString();